import React, { useState } from "react";
import axios from "axios";

import Loader from "../components/Loader";
import Error from "../components/Error";
// import Success from "../components/Success";
import GoogleLoginButton from "../components/GoogleLoginButton";
import { GoogleOAuthProvider } from '@react-oauth/google';

function LoginScreen() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function Login() {
    setLoading(true);
    const user = {
      email,
      password,
    };
    //console.log(user);
    try {
      const result = (await axios.post("/api/users/login", user)).data;
      console.log(result);
      localStorage.setItem("currentUser", JSON.stringify(result));
      const redirectUrl = sessionStorage.getItem('redirectUrl');
      console.log(redirectUrl);
      if (redirectUrl) {
        // Clear the stored redirect URL
        sessionStorage.removeItem('redirectUrl');

        // Redirect the user back to the original URL
        window.location.href=redirectUrl;
      } else {
        // If no redirect URL is stored, redirect to a default route
      window.location.href = "/home";      }
    } catch (error) {
      console.log(error);
      setError("Invalid Credentials");
    }
    setLoading(false);
  }
  return (
    <div>
      {loading && <Loader></Loader>}

      <div className="row justify-content-center mt-5">
        <div className="col-md-5 mt-5">
          {error.length > 0 && <Error msg={error}></Error>}
          <div className="bs">
            <h2>Login</h2>

            <input
              type="text"
              className="form-control"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <input
              type="password"
              className="form-control"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            {loading ? (
              <div>Login...Please Wait...</div>
            ) : (
              <button className="btn btn-primary mt-3" onClick={Login}>
                Login
              </button>
            )}
            <div className="GoogleSigninButton"  style={{display: 'flex', justifyContent: 'center', marginTop: '10px'}}>
            <GoogleOAuthProvider clientId="217188716056-06qj11ckgmbc7msoecdm17po16td4d71.apps.googleusercontent.com">
          <GoogleLoginButton />
        </GoogleOAuthProvider>
        </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;
